import { render, staticRenderFns } from "./StepStart.vue?vue&type=template&id=811f8da4"
import script from "./StepStart.vue?vue&type=script&lang=js"
export * from "./StepStart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports